import * as React from "react"
import { Box, Typography } from "@mui/material"

import { SkuLabelWrap } from "."


export default function SkuInfoBlockWrap({ sku, category, brand, maxWidth=400 }) {
    return <Box sx={{minWidth: "fit-content", whiteSpace: "nowrap", maxWidth: 500}}>
        <SkuLabelWrap label={sku} maxWidth={maxWidth}/>
        {!!category && <Typography variant="caption" sx={{display: "block", color: "text.disabled"}}>
            <Box  title={category}>
                Category: {category}
            </Box>
        </Typography>}
        {!!brand && <Typography variant="caption" sx={{display: 'block', color: "text.disabled", whiteSpace: 'normal', wordBreak: 'break-word'}}>
            Brand: {brand}
        </Typography>}
    </Box>
}